import React from 'react';

import { PricingPlanFeaturesContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPlanFeatures/PricingPlanFeatures.container';
import { PricingPlansContainer } from '@react/Pages/AccountSettingsPage/PricingPlanPage/PricingPlans/PricingPlans.container';

import './PricingPlansContent.scss';

export interface PricingPlansContentProps {
  hasAvailablePlans?: boolean;
}

export const PricingPlansContent = ({ hasAvailablePlans }: PricingPlansContentProps) =>
  hasAvailablePlans ? (
    <>
      <PricingPlanFeaturesContainer />
      <PricingPlansContainer />
    </>
  ) : (
    <div className="pricing-plans-content--no-plans-available">{t('pricing-plan.no-plans-available')}</div>
  );
